import moment from 'moment-timezone';

// Helper to convert a local datetime string (from input type="datetime-local") to ISO string in IST (Asia/Kolkata)
export function toISTISOString(localDateTimeStr) {
  if (!localDateTimeStr) return '';
  // Parse as local time and convert to IST
  const dt = moment(localDateTimeStr).tz('Asia/Kolkata');
  return dt.toISOString();
}

// Helper to convert UTC date string to IST and format for display
export function toISTString(dateStr) {
  if (!dateStr) return '';
  const dt = moment(dateStr).tz('Asia/Kolkata');
  return dt.format('DD MMM YYYY, hh:mm A');
}

// Helper to convert date string to local input format for datetime-local inputs
export function toLocalInput(dateStr) {
  if (!dateStr) return '';
  const dt = moment(dateStr).tz('Asia/Kolkata');
  return dt.format('YYYY-MM-DDTHH:mm');
}

// Helper to format date for display in IST
export function formatIST(dateStr) {
  if (!dateStr) return '';
  const dt = moment(dateStr).tz('Asia/Kolkata');
  return dt.format('DD/MM/YYYY, hh:mm A');
}

